import i18next from 'i18next';
import React, {useCallback} from 'react';

import {TextField} from '@famly/mf_input_text';
import {FormControl} from '@famly/mf_input_form-control';
import {Button} from '@famly/mf_input_button';
import {Stack} from '@famly/mf_layout_stack';
import {Box} from '@famly/mf_layout_box';
import {ModalBody, ModalHeader, ModalTopBar, PortalModal} from 'web-app/react/components/modals/modals';

import type {HandleNewTemplateNameChange} from '../types';

type Props = {
    onClose: VoidFunction;
    onSave: (isAddNewTemplateModalOpen?: boolean) => void;
    handleNewTemplateNameChange: HandleNewTemplateNameChange;
    templateName: string;
};

export const AddNewTemplateModal = ({onClose, onSave, handleNewTemplateNameChange, templateName}: Props) => {
    const handleSubmit = useCallback(() => {
        onSave(true);
    }, [onSave]);

    return (
        <PortalModal data-e2e-id="add-new-template-modal">
            <Box padding={3}>
                <ModalTopBar onCloseModal={onClose}>
                    <ModalHeader
                        header={i18next.t('react.simplifiedUsBillingPlan.translations.json.templates.addAsTemplate')}
                    />
                </ModalTopBar>
                <ModalBody>
                    <FormControl label={i18next.t('title')} fullWidth>
                        <TextField
                            data-e2e-id="new-template-title-input"
                            value={templateName}
                            onChange={e => handleNewTemplateNameChange(e.target.value)}
                        />
                    </FormControl>
                    <Stack spacing={2} width="100%" mt={6}>
                        <Button
                            variant="tertiary"
                            text={i18next.t('react.simplifiedUsBillingPlan.translations.json.cancel')}
                            onClick={onClose}
                            fullWidth
                        />
                        <Button
                            type="submit"
                            variant="primary"
                            text={i18next.t('react.simplifiedUsBillingPlan.translations.json.save')}
                            data-e2e-id="save-new-template-button"
                            fullWidth
                            onClick={handleSubmit}
                        />
                    </Stack>
                </ModalBody>
            </Box>
        </PortalModal>
    );
};
